module.exports = __webpack_public_path__ + "static/media/mockup-consulta-dark.b77a1290.png";